module.exports = __webpack_public_path__ + "img/ID_CO2_Icon.9965d558.svg";